module.exports = __webpack_public_path__ + "img/social-science.fcc4af87.svg";